import Error403 from '@projectK/modules/ErrorPages/Error403';

export default Error403;
